(function(app, ng) {
    var eventDateStructure = {
        EventDate: "date"
    };

    function datify(obj, structure) {
        if (!obj) return;
        if (ng.isArray(structure)) {
            for (var i = 0; i < obj.length; i++) {
                if (structure[0] === "date" && ng.isString(obj[i]))
                    obj[i] = new Date(obj[i]);
                if (ng.isObject(structure[0]) || ng.isArray(structure[0]))
                    datify(obj[i], structure[0]);
            }
            return;
        }
        if (ng.isObject(structure)) {
            for (var key in structure) {
                if (!structure.hasOwnProperty(key)) continue;
                if (structure[key] === "date" && ng.isString(obj[key]))
                    obj[key] = new Date(obj[key]);
                if (ng.isObject(structure[key]) || ng.isArray(structure[key]))
                    datify(obj[key], structure[key]);
            }
        }
    }

    app.provider("marketingTrackerUserApi",
    [
        function() {
            this.$get = [
                "marketingTrackerApiGateway", function(marketingTrackerApiGateway) {
                    var service = {};
                    /* TODO: Remove 
                    service.getFigAuthUserBasicEventsByDate = function (figAuthUserId, year, month, nextPageToken) {
                        var url = "/Users/FigAuth/" + figAuthUserId + "/Events/Basic/ByDate?year=" + year + "&month=" + month;
                        if (nextPageToken)
                            url += "&nextPageToken=" + nextPageToken;
                        return marketingTrackerApiGateway.getArray(url)
                            .then(function(events) {
                                ng.forEach(events,
                                    function(row) {
                                        datify(row, eventDateStructure);
                                    });
                                return events;
                            });
                    };

                    service.getFigAuthUserBasicAncillaryEventsByDate = function(figAuthUserId, year, month, nextPageToken) {
                        var url = "/Users/FigAuth/" + figAuthUserId + "/AncillaryEvents/Basic/ByDate?year=" + year + "&month=" + month;
                        if (nextPageToken)
                            url += "&nextPageToken=" + nextPageToken;
                        return marketingTrackerApiGateway.getArray(url)
                            .then(function (events) {
                                ng.forEach(events,
                                    function (row) {
                                        datify(row, eventDateStructure);
                                    });
                                return events;
                            });
                    };

                    service.getFigAuthUserAllEvents = function(figAuthUserId, nextPageToken) {
                        var url = "/Users/FigAuth/" + figAuthUserId + "/Events/All";
                        if (nextPageToken)
                            url += "?nextPageToken=" + nextPageToken;
                        return marketingTrackerApiGateway.getArray(url)
                            .then(function (events) {
                                ng.forEach(events,
                                    function (row) {
                                        datify(row, eventDateStructure);
                                    });
                                return events;
                            });
                    };
                    */
                    service.getUserBasicEventsByDate = function (year, month, nextPageToken) {
                        var url = "/Users/Events/Basic/ByDate?year=" + year + "&month=" + month;
                        if (nextPageToken)
                            url += "&nextPageToken=" + nextPageToken;
                        return marketingTrackerApiGateway.getArray(url)
                            .then(function (events) {
                                ng.forEach(events,
                                    function (row) {
                                        datify(row, eventDateStructure);
                                    });
                                return events;
                            });
                    };

                    service.getUserBasicAncillaryEventsByDate = function (year, month, nextPageToken) {
                        var url = "/Users/AncillaryEvents/Basic/ByDate?year=" + year + "&month=" + month;
                        if (nextPageToken)
                            url += "&nextPageToken=" + nextPageToken;
                        return marketingTrackerApiGateway.getArray(url)
                            .then(function (events) {
                                ng.forEach(events,
                                    function (row) {
                                        datify(row, eventDateStructure);
                                    });
                                return events;
                            });
                    };

                    service.getUserAllEvents = function (nextPageToken) {
                        var url = "/Users/Events/All";
                        if (nextPageToken)
                            url += "?nextPageToken=" + nextPageToken;
                        return marketingTrackerApiGateway.getArray(url)
                            .then(function (events) {
                                ng.forEach(events,
                                    function (row) {
                                        datify(row, eventDateStructure);
                                    });
                                return events;
                            });
                    };

                    service.actingUserIsAdminstrator = function () {
                        return marketingTrackerApiGateway.get("/Users/ActingUser/IsAdministrator/");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app, window.angular);